module.exports = __webpack_public_path__ + "media/frontend/components/home/homeBanner-73adb9fd8def25d60f9462dc29374150.png";